import { Request } from '../request';
import { GetOpsDetailInput } from 'types/operation';
import { TAcceptInviteReq } from 'types/invite';

export enum ERegisterType {
    KIWI_PORTAL = 'KIWI_PORTAL',
    KLARITY_PORTAL = 'KLARITY_PORTAL',
}

export type TRegisterWithPwd = {
    email: string;
    inform: 0 | 1;
    password: string;
    signUpFrom?: string;
    tel?: string;
    type?: ERegisterType;
    utm?: null | {
        utmSource?: string;
        utmMedium?: string;
        utmCampaign?: string;
        utmTerm?: string;
        utmContent?: string;
    };
};

export const registerWithPwd = (data: TRegisterWithPwd) =>
    Request.post({
        url: '/schedule-server/public/provider/registerWithPwd',
        params: data,
        disableErrorNote: true,
    });

type TLoginWithPwd = {
    email: string;
    password: string;
    type?: ERegisterType;
};

export const loginWithPwd = (data: TLoginWithPwd) =>
    Request.post({
        url: '/schedule-server/public/provider/loginWithPwd',
        params: data,
        disableErrorNote: true,
    });

type TSendForget = {
    email: string;
};

export const sendForget = (data: TSendForget) =>
    Request.post({
        url: '/schedule-server/public/provider/sendForget',
        params: data,
        disableErrorNote: true,
    });

export const sendForgetKlarity = (data: TSendForget) =>
    Request.post({
        url: '/schedule-server/public/provider/sendForget/v2',
        params: data,
        disableErrorNote: true,
    });

export type TRegisterWithoutPwd = {
    credential: string;
    inform: 0 | 1;
    signUpFrom?: string;
    type?: ERegisterType;
};

export const registerWithoutPwd = (data: TRegisterWithoutPwd) =>
    Request.post({
        url: '/schedule-server/public/provider/registerWithoutPwd',
        params: data,
        disableErrorNote: true,
    });

type TLoginWithoutPwd = {
    credential: string;
    type?: ERegisterType;
};

export const loginWithoutPwd = (data: TLoginWithoutPwd) =>
    Request.post({
        url: '/schedule-server/public/provider/loginWithoutPwd',
        params: data,
    });

type TSavePassword = {
    code: number;
    email: string;
    password: string;
    type: ERegisterType;
};

export const savePassword = (data: TSavePassword) =>
    Request.post({
        url: '/schedule-server/public/provider/savePassword',
        params: data,
        disableErrorNote: true,
    });

type ICheckEmail = {
    email?: string;
    code?: string;
};

export const checkMail = (data: ICheckEmail) =>
    Request.post({
        url: '/schedule-server/public/provider/checkMail',
        params: { code: data?.code ? parseInt(data.code) : '', email: data.email },
    });

export const sendVerify = (email: string, source?: string, sourceId?: string) =>
    Request.post({
        url: '/schedule-server/public/provider/verify',
        params: { email: email, source, sourceId },
    });

type TRegisterAndLogin = {
    email: string;
    password: string;
    type: ERegisterType;
    inform?: 0 | 1;
    tel?: number;
    signUpFrom?: string;
    verifyCode?: string; // 注册必填：step1 校验通过的 OTP，后端会再校一次并作废
    utm?: null | {
        utmSource?: string;
        utmMedium?: string;
        utmCampaign?: string;
        utmTerm?: string;
        utmContent?: string;
    };
    isLogin: boolean;
};

export const registerAndLogin = (data: TRegisterAndLogin) =>
    Request.post({
        url: '/schedule-server/public/provider/registerAndLogin',
        params: data,
        disableErrorNote: true,
    });

// 切换账户相关接口
export const generateSwitchKey = () =>
    Request.post({
        url: '/schedule-server/public/api/v1/switch-account/generate-key',
        disableErrorNote: true,
    });

export const authUserWithSwitchKey = (generatedSwitchKey: string) =>
    Request.get({
        url: `/schedule-server/public/api/v1/switch-account/auth-user/${generatedSwitchKey}`,
        disableErrorNote: true,
    });

export const opsExchangeCode = (code: string) =>
    Request.post({
        url: '/schedule-server/public/api/v1/switch-account/ops-exchange',
        params: { code },
        disableErrorNote: true,
    });

export const getTeamMemberInviteInfo = (token: string) =>
    Request.get<{ token: string }>({
        url: '/schedule-server/public/team-member/invite-info',
        params: { token },
        disableErrorNote: true,
    });

export const acceptTeamMemberInvite = (data: TAcceptInviteReq) =>
    Request.post<TAcceptInviteReq>({
        url: '/schedule-server/public/team-member/accept-invite',
        params: data,
        disableErrorNote: true,
    });
